import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = [
  {
    id: "fb-1",
    nome: "Giuseppe Ferrario",
    localita: "Abbiategrasso (MI)",
    servizio: "Pannelli finto coppo coibentati",
    stelle: 5,
    testo: "Hanno rifatto completamente il tetto del nostro cascinale con pannelli coibentati. Cantiere pulito, tempi rispettati e risultato impeccabile.",
  },
  {
    id: "fb-2",
    nome: "Maria Colombo",
    localita: "Magenta (MI)",
    servizio: "Impermeabilizzazione in guaina",
    stelle: 5,
    testo: "Avevamo infiltrazioni sul terrazzo da anni e nessuno riusciva a risolverle. Sopralluogo accurato, preventivo chiaro e problema eliminato.",
  },
  {
    id: "fb-3",
    nome: "Roberto Sala",
    localita: "Vigevano (PV)",
    servizio: "Copertura in tegole tradizionali",
    stelle: 5,
    testo: "Posa delle tegole portoghesi fatta con una cura artigianale rara. Cantiere lasciato in ordine ogni sera. Consigliatissimi.",
  },
  {
    id: "fb-4",
    nome: "Laura Brambilla",
    localita: "Milano",
    servizio: "Lattoneria e grondaie in rame",
    stelle: 4,
    testo: "Grondaie in rame sostituite su tutta la villetta, lavoro preciso e bello da vedere. Ottima impresa.",
  },
];

const Stars = ({ n }) => (
  <div className="flex gap-1" aria-label={`${n} stelle su 5`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        size={14}
        className={i <= n ? "text-[#D97736] fill-[#D97736]" : "text-[#3A3E47]"}
        strokeWidth={1.5}
      />
    ))}
  </div>
);

export default function Reviews() {
  const [reviews, setReviews] = useState(FALLBACK);

  useEffect(() => {
    axios
      .get(`${API}/recensioni`)
      .then((r) => {
        if (Array.isArray(r.data) && r.data.length > 0) setReviews(r.data);
      })
      .catch(() => {});
  }, []);

  return (
    <section id="recensioni" className="py-24 sm:py-32" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mb-14 max-w-3xl"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D97736] mb-4">Dicono di noi</p>
          <h2 className="font-syne font-bold tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl">
            La fiducia si costruisce tetto dopo tetto.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {reviews.map((r, i) => (
            <motion.figure
              key={r.id}
              data-testid={`review-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 4) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="flex flex-col bg-[#14171E] border border-white/10 hover:border-[#D97736]/40 rounded-3xl p-7 transition-colors duration-500"
            >
              <Quote size={22} className="text-[#D97736]/60 mb-4" strokeWidth={1.5} />
              <blockquote className="text-sm text-[#C9CDD4] leading-relaxed flex-1 mb-6">{r.testo}</blockquote>
              <figcaption>
                <Stars n={r.stelle} />
                <p className="font-syne font-semibold text-sm text-[#F3F4F6] mt-3">{r.nome}</p>
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#6B7280] mt-1">
                  {r.localita} · {r.servizio}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
